/* global barba, barbaRouter, scrollDepth */
import vars from './helpers';
import lazyLoading from './modules/lazyLoading';
import lazyBlure from './modules/lazyBlure';
import home from './pages/home';
import article from './pages/article';
import share from './share';
import menu from './components/menu';
import preloader from "./components/preloader";

// import share from "./components/share";


// if (history.scrollRestoration) {
// 	history.scrollRestoration = 'manual';
// }

const setDataPage = (data) => {
	vars.$html.addClass(`page-${data}`);
};

const removeDataPage = (data) => {
	vars.$html.removeClass(`page-${data}`);
};

const routes = [ // здесь добавляем роуты страниц
	{
		path: '/',
		name: 'index',
	},
	{
		path: '/article-1',
		name: 'article-1',
	},
];

barba.use(barbaRouter, {
	routes,
});

barba.hooks.enter((data) => {
	vars.$document.trigger(
		'page-enter',
		[data.current.namespace, data.next.namespace], // обработчик для аналитики
	);
});

barba.hooks.beforeEnter(() => {
	vars.scrollTo(vars.$html, 0);
	vars.$html.removeClass('no-scroll');
});

barba.hooks.afterEnter((data) => {
	const container = data.next.container;
	lazyBlure.init();
	lazyLoading.init();

	share.init(data);
	menu.init(container);

	let currentPageData = $(data.next.container).attr('data-page');
	setDataPage(currentPageData);

	if (data.next.namespace === 'home') {
		$(data.next.container).find('.is-page-preload').addClass('hide');

		home.init(container);
		preloader.init(container);

		if(data.current.namespace === 'article') {
			let pageID = data.current.container.dataset.id - 1;
			home.initSwiper(pageID);
			home.initBackground(pageID);
			home.initContent(pageID);
		} else {
			home.initSwiper();
			home.initBackground();
			home.initContent();
		}
	}

	if (data.next.namespace === 'article') {
		home.destroy();

		article.init(container);
		// preloader.init(data.next.namespace);

		$(data.next.container).find('.is-page-preload').addClass('hide');
	}
});

barba.hooks.beforeLeave(({current}) => {

});

barba.hooks.afterLeave(({current}) => {
	let currentPageData = $('.page-container').attr('data-page');
	removeDataPage(currentPageData);
	menu.destroy();

	article.destroy();
});

// init Barba
barba.init({
	sync: true,
	timeout: 5000,
	preventRunning: true,
	transitions: [
		{
			name: 'none',
			leave(data) {
				let done = this.async();

				gsap.to(data.current.container, {
					duration: 0.15,
					autoAlpha: 0,
					onComplete: () => {
						done();
					},
				});
			},
			enter(data) {
				let done = this.async();
				gsap.from(data.next.container, {
					duration: 0.15,
					autoAlpha: 0,
					onComplete: done,
				});
			},
			appear() {
			},
		},
		{
			name: 'slide-enter[-index]',
			appear() {
			},
		},
	],

	views: [
		{
			namespace: 'index',
		},
	],
});
export default barba;
